import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import './final-report.scss';
import { DashboardHeader } from '../../atoms';
import { DashContentFooter, FinalReportContainer } from '../../molecules';
import { DashboardContext, UserContext } from '../../../context';
import ReportsContainer from '../../molecules/reports-container/reports-container';

function FinalReport() {
  const [dashData, setDashData] = useState({});

  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className="row no-gutters">
        <div className="no-gutters dash-left-wrapper">
          <DashboardHeader />
          <FinalReportContainer/>
          <DashContentFooter className="footer-margin" />
        </div>
      </div>
    </DashboardContext.Provider>
  );
}

export default FinalReport;
